<template>
    <div>
        <div class="flex gap-x-5" :class="`justify-center`">
            <div
                class="bg-white py-3 px-6 shadow-md text-right rounded-md flex items-center gap-5"
                :class="`${cryptos.length <= 3 ? '' : 'justify-center'} ${cryptos.length === 1 ? 'flex-1' : ''}`"
            >
                <div v-for="n in 4" :key="n" v-show="loadingCrypto" class="flex justify-center items-center w-64 h-28">
                    <div>
                        <i class="fas fa-spinner animate-spin text-2xl" />
                    </div>
                </div>
                <div v-show="!loadingCrypto" class="flex justify-between items-start">
                    <div class="py-2 px-3 bg-gray-100 rounded-full">
                        <i class="fas fa-hand-holding-usd text-gray-400"/>
                    </div>
                    <div class="text-left ml-4">
                        <div class="text-xxs text-gray-500">
                            Disponível para saque
                        </div>
                        <div class="text-lg font-bold text-black">
                            {{ numberFormat(balance.withdraw) }} BRL
                        </div>
                        <div class="text-xxs text-gray-500">
                            Atualizado em {{ balance.request_date | smallDateTime }}
                        </div>
                    </div>
                </div>
                <div v-show="!loadingCrypto" class="flex justify-between items-start">
                    <div class="py-2 px-3 bg-gray-100 rounded-full">
                        <i class="fas fa-check text-gray-400"/>
                    </div>
                    <div class="text-left ml-4">
                        <div class="text-xxs text-gray-500">
                            Disponível para compra
                        </div>
                        <div class="text-lg font-bold text-green-500">
                            {{ numberFormat(balance.limit) }} BRL
                        </div>
                        <div class="text-xxs text-gray-500">
                            Atualizado em {{ balance.request_date | smallDateTime }}
                        </div>
                    </div>
                </div>
                <div v-show="!loadingCrypto" class="flex justify-between items-start">
                    <div class="py-2 px-3 bg-gray-100 rounded-full">
                        <i class="fas fa-cash-register text-gray-400"/>
                    </div>
                    <div class="text-left ml-4">
                        <div class="text-sm text-gray-500">
                            Total comprado convertido em reais
                        </div>
                        <div class="text-lg font-bold text-red-500">
                            {{ numberFormat(balance.total) }} BRL
                        </div>
                        <div class="text-xxs text-gray-500">
                            Atualizado em {{ balance.request_date | smallDateTime }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- TODO: Create repeat -->
            <template v-if="cryptos.length === 1">
                <div v-for="crypto in cryptos" :key="crypto.key">
                    <card-currency :crypto="crypto" :balance="balance" :loading="loadingCrypto"/>
                </div>
            </template>
        </div>
        <div v-if="cryptos.length > 1" class="grid mt-5 gap-x-5" :class="colsBalances">
            <div v-for="crypto in cryptos" :key="crypto.key">
                <card-currency :crypto="crypto" :balance="balance" :loading="loadingCrypto"/>
            </div>
        </div>
    </div>
</template>

<script>
import eventBus from "../../Layouts/eventBus";
import numberFormat from "./utils/numberFormat";
import CardCurrency from "./components/CardCurrency.vue";

export default {
    props: {
        value: String,
        maxWidth: {
            type: Number,
            default: 300
        },
        height: {
            type: String,
            default: '10'
        },
        placeholder: {
            type: String,
            default: 'Buscar'
        },
    },
    data() {
        return {
            balance: {
                total: 0,
                limit: 0,
                request_date: 0,
            },
            loadingCrypto: false,
            cryptos: [],
            numberFormat,
        }
    },
    computed: {
        colsBalances(){
            return `grid-cols-${this.cryptos.length}`
        }
    },
    methods: {
        getBalance() {
            this.loadingCrypto = true
            axios.get('/crypto/balance')
                .then(response => {
                    this.balance = response.data.list;

                    const cryptosWithValue = Object.keys(response.data.list?.crypto ?? {}).map(key => ({
                        key,
                        ...response.data.list.crypto[key]
                    })).filter(item => item.crypto_amount)

                    this.cryptos = cryptosWithValue;
                }).finally(() => this.loadingCrypto = false);
        }
    },
    created() {
        eventBus.$on("clearFilter", () => {
            this.$emit('input', null);
        });
        this.getBalance();
    },
    components: {
        CardCurrency,
    },

}
</script>

